import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static outlets = ["store-audio--recorder"]
  static targets = ["visualizer"]

  activate(event) {
    if (event.type === "recording") {
      this.visualizerTarget.parentElement.classList.remove("hidden");
    }

    const audioContext = new AudioContext();
    const source = audioContext.createMediaStreamSource(this.storeAudioRecorderOutlet.stream);

    this.analyser = audioContext.createAnalyser();
    this.analyser.fftSize = 256;
    source.connect(this.analyser);

    this.dataArray = new Uint8Array(this.analyser.frequencyBinCount);

    const canvas = this.visualizerTarget;
    const canvasContext = canvas.getContext("2d");

    const totalBars = 24;
    const spacing = 9;
    const cornerRadius = 5;
    const minBarHeight = 15;

    const draw = () => {
      canvasContext.clearRect(0, 0, canvas.width, canvas.height);
      this.analyser.getByteFrequencyData(this.dataArray);

      const actualBarWidth =
        (canvas.width - (totalBars - 1) * spacing) / totalBars;

      for (let i = 0; i < totalBars / 2; i++) {
        const barHeight = Math.max(
          (this.dataArray[i] / 220) * (canvas.height / 2),
          minBarHeight,
        );

        const leftX = canvas.width / 2 - (i + 1) * (actualBarWidth + spacing);
        const rightX = canvas.width / 2 + i * (actualBarWidth + spacing);

        canvasContext.fillStyle = "#3FC678";

        this.#drawRoundedRect(
          canvasContext,
          leftX,
          canvas.height / 2 - barHeight,
          actualBarWidth,
          barHeight,
          cornerRadius,
          true,
          false,
        );

        this.#drawRoundedRect(
          canvasContext,
          leftX,
          canvas.height / 2,
          actualBarWidth,
          barHeight,
          cornerRadius,
          false,
          true,
        );

        this.#drawRoundedRect(
          canvasContext,
          rightX,
          canvas.height / 2 - barHeight,
          actualBarWidth,
          barHeight,
          cornerRadius,
          true,
          false,
        );

        this.#drawRoundedRect(
          canvasContext,
          rightX,
          canvas.height / 2,
          actualBarWidth,
          barHeight,
          cornerRadius,
          false,
          true,
        );
      }

      this.animationId = requestAnimationFrame(draw);
    };

    draw();

    this.visualizerTarget.dataset.state = "play";
  }

  freeze() {
    cancelAnimationFrame(this.animationId);
    const canvas = this.visualizerTarget;
    const canvasContext = canvas.getContext("2d");
    canvasContext.clearRect(0, 0, canvas.width, canvas.height);

    this.visualizerTarget.dataset.state = "pause";
  }

  handleRecording(event) {
    if (event.detail.status === "started") {
      this.activate(event)
    } else {
      this.freeze();
    }
  }

  #drawRoundedRect(
    context,
    x,
    y,
    width,
    height,
    radius,
    roundTop,
    roundBottom,
  ) {
    context.beginPath();

    if (roundTop) {
      context.moveTo(x + radius, y);
      context.lineTo(x + width - radius, y);
      context.quadraticCurveTo(x + width, y, x + width, y + radius);
    } else {
      context.moveTo(x, y);
      context.lineTo(x + width, y);
    }

    if (roundBottom) {
      context.lineTo(x + width, y + height - radius);
      context.quadraticCurveTo(
        x + width,
        y + height,
        x + width - radius,
        y + height,
      );
    } else {
      context.lineTo(x + width, y + height);
    }

    if (roundBottom) {
      context.lineTo(x + radius, y + height);
      context.quadraticCurveTo(x, y + height, x, y + height - radius);
    } else {
      context.lineTo(x, y + height);
    }

    if (roundTop) {
      context.lineTo(x, y + radius);
      context.quadraticCurveTo(x, y, x + radius, y);
    } else {
      context.lineTo(x, y);
    }

    context.closePath();
    context.fill();
  }
}
